import React from 'react';
import { Box, Typography } from '@mui/material';
import DocumentViewer from '../../../Components/Ui/DocumentViewer';
import FileButton from '../../File/M_FILE_CUSTOM/ui/FileButton';

export default function M_GUIDE_BASIC_01(props) {
  const {
    fullUrl,
    renderPreview,
    loading,
    onDocumentLoadSuccess,
    pageNumber,
    pageWidth,
    pageViewHeight,
    setPageViewHeight,
    goToPrevPage,
    goToNextPage,
    onAdvanceStep,
    numPages,
  } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        bgcolor: '#fff',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Typography
          sx={{ color: '#828282', fontSize: 14, px: 2, pt: 1, flexShrink: 0 }}
        >
          PDF 매뉴얼을 확인해주세요.
        </Typography>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'auto',
          }}
        >
          <Box
            key={fullUrl}
            sx={{
              width: '100%',
              height: '100%',
              minHeight: 0,
            }}
          >
            <DocumentViewer
              renderPreview={renderPreview}
              loading={loading}
              onDocumentLoadSuccess={onDocumentLoadSuccess}
              pageNumber={pageNumber}
              pageWidth={pageWidth}
              pageViewHeight={pageViewHeight}
              setPageViewHeight={setPageViewHeight}
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Box>
        </Box>
        <Box sx={{ flexShrink: 0, width: '100%' }}>
          <FileButton
            goToPrevPage={goToPrevPage}
            goToNextPage={goToNextPage}
            onAdvanceStep={onAdvanceStep}
            pageNumber={pageNumber}
            numPages={numPages}
          />
        </Box>
      </Box>
    </Box>
  );
}
